import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialNavigationMenu1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.71 3.81h1.53v24.38h-1.53Zm-1.52 24.38h1.52v1.52h-1.52Zm0-25.91h1.52v1.53h-1.52ZM3.81 29.71h24.38v1.53H3.81Zm19.81-10.67h3.05v-1.52h1.52v-3.05h-1.52v-1.52h-3.05v1.52H22.1v3.05h1.52zm-9.14 0h3.04v-1.52h1.53v-3.05h-1.53v-1.52h-3.04v1.52h-1.53v3.05h1.53zm-9.15-6.09v1.52H3.81v3.05h1.52v1.52h3.05v-1.52h1.53v-3.05H8.38v-1.52zM3.81.76h24.38v1.52H3.81ZM2.29 28.19h1.52v1.52H2.29Zm0-25.91h1.52v1.53H2.29ZM.76 3.81h1.53v24.38H.76Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialNavigationMenu1
